import createSagaMiddleware from 'redux-saga'

const sagaMiddleware = createSagaMiddleware()

export const runSaga = (...args) => sagaMiddleware.run(...args)

export default sagaMiddleware
